<script>
import { mapGetters } from 'vuex'
import TransactionRow from '@components/transaction-row'
import SubHeader from '@components/sub-header'
import InfoBox from '@components/info-box'

export default {
  name: 'TransactionDetail',
  components: {
    TransactionRow,
    SubHeader,
    InfoBox,
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('widgets', ['widgetProperty']),
    orderData () {
      return this.widgetProperty('SharedData', 'orderData')
    },
    isCreditCard () {
      return this.orderData.payment_method === 'cc'
    },
    withTransactions () {
      return this.componentData.transactions.length > 0
    },
    infoBoxData () {
      return {
        data: {
          icon: 'error',
          text: this.$t('WIDGETS.TRANSACTION_DETAIL.INFO_BOX.COPY'),
        },
      }
    },
    totalAmount () {
      return {
        text: this.$t('WIDGETS.TRANSACTION_DETAIL.TOTAL_COPY')
      }
    }
  },
}
</script>

<template>
  <div
    v-if="withTransactions"
    :class="$style.container"
  >
    <p :class="$style.container__title">{{ componentData.title }}</p>

    <div :class="$style.container__table">
      <TransactionRow
        v-for="(transaction, index) in componentData.transactions"
        :key="index"
        :transaction="transaction"
        :order="orderData"
        @click="validateDeepLinkToCall(complaintType)"
      />

      <InfoBox
        :data="JSON.parse(JSON.stringify(infoBoxData.data))"
        :class="$style.infoBox"
      />

      <v-layout :class="$style.container__total">
        <v-flex
          :class="$style.container__total__text"
          xs8
        >
          {{ totalAmount.text }}
        </v-flex>

        <v-flex
          :class="$style.container__total__amount"
          xs3
          offset-xs1
        >{{ componentData.total.value }}</v-flex>
      </v-layout>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  padding: 1rem 0.1rem;
  margin: $size-spacing-medium 0;
  background-color: $background-container;

  &__title {
    @extend %typography-large;

    margin: 0 $size-spacing-large 0 $size-spacing-medium;
    color: $darker-gray;
    text-align: left;
    font-weight: bold;
    font-style: normal;
    line-height: normal;
    padding-bottom: 1.5rem;
    padding-top: $size-spacing-small;
    border-bottom: 1px solid $divider-gray;
  }

  &__copy {
    @extend %typography-medium;

    margin: 1rem 1rem 1rem 1rem;
    color: $charcoal-gray;
    text-align: left;
  }

  &__table {
    text-align: left !important;
    background-color: transparent;
  }

  &__total {
    @extend %typography-medium;

    padding: 1rem 1.75rem;
    margin-top: 2rem;

    &__text {
      @extend %typography-medium;

      color: $darker-gray !important;
    }

    &__amount {
      font-weight: 700;
      color: $darker-gray !important;
      text-align: right;
    }
  }
}

.infoBox {
  margin: 1rem auto;
  margin-bottom: 0rem;
}
</style>
